<template>
  <v-list-item dense :class="[item.new ? 'newcolor' : '', item.changed ? 'changecolor' : '']" @click="$emit('click')">
    <v-list-item-icon class="my-auto mr-3">
      <v-icon v-text="'mdi-brightness-auto'" size="16" />
    </v-list-item-icon>
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        {{ item.Name }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="mr-5">
      <v-badge v-if="item.new || item.changed"
        :content="item.new ? $t('servicesystem.common_objects.commonterms.new') : $t('servicesystem.common_objects.commonterms.changed')"
        :color="item.new ? 'green' : 'orange'" :offset-x="0" :offset-y="10">
      </v-badge>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "LeadTypeListItem",
  props: {
    item: Object,
  },
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>